// extracted by mini-css-extract-plugin
export default {"component":"Breadcrumbs__component--lc-eEouO","icon":"Breadcrumbs__icon--lc-KTWKz","title":"Breadcrumbs__title--lc-Bpum3"};